module.exports = __webpack_public_path__ + "static/media/AI_smmary_GreyIcon.c1a2e634.svg";